import { NgModule } from '@angular/core';
import { RouterModule, Routes ,Router, NavigationEnd} from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { BoRolesCheckService } from './components/rolesCheck/bo-roles-check.service';
import { BtbRolesCheckService } from './components/rolesCheck/btb-roles-check.service';
import { CheckoutNotificationComponent } from './features/checkout-notification/checkout-notification.component';
import { EditMyProfileComponent } from './features/my-profile/edit-profile/edit-profile.component';
import { MyProfileComponent } from './features/my-profile/my-profile.component';
import { ContactDetailsComponent } from './features/contacts/contact-details/contact-details.component';
import { ContactsComponent } from './features/contacts/contacts.component';
import { NewContactComponent } from './features/contacts/new-contact/new-contact.component';
import { HistoryComponent } from './features/history/history.component';
import { HomeComponent } from './features/home/home.component';
import { HomeDashboardComponent } from './features/home/dashboard.component';
import { PromosComponent } from './features/home/promos.component';
import { RechargesComponent } from './features/recharges/recharges.component';
import { SendMoneyComponent } from './features/send-money/send-money.component';
import { TransfersComponent } from './features/transfers/transfers.component';
import { EsimComponent } from './features/esim/esim.component';
import { MyEsimsComponent } from './features/esim/my-esims/my-esims.component';
import { TopupComponent } from './features/esim/topup/topup.component';
import { DetailsComponent } from './features/esim/details/details.component';
import { UserEsimDetailsComponent } from './features/esim/user-esim-details/user-esim-details.component';
// import { NewCostumerComponent } from './features/ISP/newCostumer.component';

// bo
import { BODashboardComponent } from './features/backoffice/BODashboard.component';
import { BOUsersComponent } from './features/backoffice/users/users.component';
import { BOUserProfileComponent } from './features/backoffice/users/user-profile.component';
import { BOEditUserComponent } from './features/backoffice/users/edit-user.component';
import { BOEsimListComponent } from './features/backoffice/users/esimList.component';
import { BOPartnersComponent } from './features/backoffice/partners/partners.component';
import { PartnerDetailComponent } from './features/backoffice/partners/partner-detail.component';
import { TransaccionesComponent } from './features/backoffice/Transactions/Transacciones.component';
import { TransaccionDetailComponent } from './features/backoffice/Transactions/transactionDetail.component';
import { BOPricingListComponent } from './features/backoffice/calls-pricing/calls-pricing-list.component';
import { BOEditCallPriceComponent } from './features/backoffice/calls-pricing/edit-call-price.component';
import { BOErrorLogComponent } from './features/backoffice/error-log/error-log.component';
import { Configcomponent } from './features/backoffice/Config/Config.component';
import { EditConfigComponent } from './features/backoffice/Config/edit-config.component';
import { BOHoldedToSageComponent } from './features/backoffice/document-processing/holded-to-sage/holded-to-sage.component';
import { BOHoldedToSageComponent2025 } from './features/backoffice/document-processing/holded-to-sage-2025/holded-to-sage.component';
import { DocumentProcessingComponent } from './features/backoffice/document-processing/herramientas.component';
import { CdrProcessingComponent } from './features/backoffice/document-processing/cdr-processing/cdr-processing.component';
import { TxUsuariosComponent} from './features/backoffice/Transactions/TxUsuarios.component';
import { AddBalanceComponent} from './features/backoffice/users/AddBalance.Component';
import { BOEsimGiftComponent } from './features/backoffice/users/bo-esim-gift/bo-esim-gift.component';
import { BOEsimGiftDetailsComponent } from './features/backoffice/users/bo-esim-gift-details/bo-esim-gift-details.component';
import { EsimCatalogComponent } from './features/backoffice/esim-catalog/esim-catalog.component';
import { DocumentStoreComponent } from './features/backoffice/document-store/document-store.component';
import { CdrBillingComponent } from './features/backoffice/cdr-billing/cdr-billing.component';

// btb
import { btbDashboardComponent } from './features/btb/Dashboard.component';
import { EditMyProfileComponent as EditMyProfileComponentBTB } from './features/btb/my-profile/edit-profile/edit-profile.component';
import { MyProfileComponent as MyProfileComponentBTB } from './features/btb/my-profile/my-profile.component';

import { filter } from 'rxjs';
import { EditItemsComponent } from './features/backoffice/PromoyCondiciones/edit-items.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.module').then((m) => m.OnBoardingModule),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./features/about/about.module').then((m) => m.AboutModule),
  },
  { path: 'esimpublic', component: EsimComponent },
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      { path: 'esim', component: EsimComponent },
      { path: 'my-esims', component: MyEsimsComponent },
      { path: 'topup/:iccid', component: TopupComponent },
      { path: 'esim-details', component: DetailsComponent },
      { path: 'user-esim-details/:iccid', component: UserEsimDetailsComponent },
      { path: 'home', component: HomeComponent },
      { path: 'dashboard', component: HomeDashboardComponent },
      { path: 'home/promos', component: PromosComponent },
      { path: 'send-money', component: SendMoneyComponent },
      { path: 'contacts', component: ContactsComponent },
      { path: 'contacts/new-contact', component: NewContactComponent },
      { path: 'contacts/new-contact/:telephone', component: NewContactComponent },
      { path: 'contacts/edit-contact/:id', component: NewContactComponent },
      { path: 'contact/details/:id', component: ContactDetailsComponent },
      { path: 'recharges', component: RechargesComponent },
      { path: 'transfers', component: TransfersComponent },
      // { path: 'altausuario',component:NewCostumerComponent },
      {
        path: 'transfers/validate/:status',
        component: CheckoutNotificationComponent,
      },
      {
        path: 'recharges/checkout/:status',
        component: CheckoutNotificationComponent,
      },
      {
        path: 'checkout/:status',
        component: CheckoutNotificationComponent,
      },
      { path: 'history', component: HistoryComponent },
      {
        path: 'calls',
        loadChildren: () =>
          import('./features/calls/calls.module').then((m) => m.CallsModule)
      },
      { path: 'profile', component: MyProfileComponent },
      { path: 'profile/edit', component: EditMyProfileComponent },
    ],
  },
  {
    path: 'backoffice',
    canActivate: [AuthGuardService, BoRolesCheckService],
    children: [
      { path: '', component: BODashboardComponent },
      { path: 'dashboard', component: BODashboardComponent },
      { path: 'users', component: BOUsersComponent },
      { path: 'users/edit/:userId', component: BOEditUserComponent },
      { path: 'users/:userId', component: BOUserProfileComponent },
      { path: 'users/esims/:userId', component: BOEsimListComponent },
      { path: 'users/:userId/gift-esim', component: BOEsimGiftComponent },
      { path: 'users/:userId/gift-esim/:packageId', component: BOEsimGiftDetailsComponent },
      { path: 'partners', component: BOPartnersComponent },
      { path: 'partners/:userId', component: PartnerDetailComponent },
      { path: 'transactions', component: TransaccionesComponent  },
      { path: 'calls-pricing', component: BOPricingListComponent  },
      { path: 'calls-pricing/edit', component: BOEditCallPriceComponent  },
      { path: 'transactions/detail', component: TransaccionDetailComponent  },
      { path: 'errors', component: BOErrorLogComponent  },
      { path: 'configs', component: Configcomponent  },
      { path: 'config/edit', component: EditConfigComponent  },
      { path: 'holded-to-sage200', component: BOHoldedToSageComponent  },
      { path: 'holded-to-sage200-2025', component: BOHoldedToSageComponent2025  },
      { path: 'herramientas', component: DocumentProcessingComponent  },
      { path: 'cdr-processing', component: CdrProcessingComponent  },
      { path: 'txusuarios', component: TxUsuariosComponent  },
      { path: 'conditions/:type', component: EditItemsComponent },
      { path: 'addbalance', component: AddBalanceComponent },
      { path: 'esim-catalog', component: EsimCatalogComponent },
      { path: 'document-store', component: DocumentStoreComponent },
      { path: 'cdr-billing',   component: CdrBillingComponent }
    ]
  },
  {
    path: 'btb',
    canActivate: [AuthGuardService, BtbRolesCheckService],
    children: [
      { path: '', component: btbDashboardComponent },
      { path: 'dashboard', component: btbDashboardComponent },
      { path: 'profile', component: MyProfileComponentBTB },
      { path: 'profile/edit', component: EditMyProfileComponentBTB },
    ]
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {
  constructor(private router: Router) {}

  ngOnInit() {
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(() => {
    //   this.validateAccessByUrl();
    // });
  }

  validateAccessByUrl() {
    const url = this.router.url; // Ej: /cliente/dashboard
    const userAccess = localStorage.getItem('userPortal') || ''; // aquí obtienes 'cliente', 'backoffice', etc

    if (!url.includes(userAccess)) {
      // Opcional: redirigir a un acceso no autorizado o home
      this.router.navigate(['/acceso-denegado']);
    }
  }
}
